import React from "react";
import IsolationPermitStepPage from "./IsolationPermitStepPage";

function CetificateEnergisation(props) {
  return (
    <IsolationPermitStepPage {...props} step="energisation_certificate" />
  );
}

export default CetificateEnergisation;
